import * as action_types from '../actions/action_types';

const initialState = {
  w1Size: 5,
  w2Size: 7,
};

export const WidgetSettingReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case action_types.CONFIGURE:
      return {
        ...state,
        w1Size: action.data.w1Size,
        w2Size: action.data.w2Size,
      };
    default:
      return state;
  }
};
